// extracted by mini-css-extract-plugin
module.exports = {"product-card":"ErrorFallback_product-card__k68Le","fallback_container":"ErrorFallback_fallback_container__PO6j2","fallback_info":"ErrorFallback_fallback_info__Jw44S"};